import { render, staticRenderFns } from "./NavigationButtons.vue?vue&type=template&id=610dfa71&scoped=true&"
import script from "./NavigationButtons.vue?vue&type=script&lang=js&"
export * from "./NavigationButtons.vue?vue&type=script&lang=js&"
import style0 from "./NavigationButtons.vue?vue&type=style&index=0&id=610dfa71&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610dfa71",
  null
  
)

export default component.exports